export default {
  saveUser: {
    uri: 'users',
    method: 'POST',
    loading: true,
    subdomain: true,
    needsVerified: false
  },
  updateUser: {
    uri: 'users/%user%',
    method: 'PUT',
    loading: true,
    subdomain: true,
    needsVerified: true
  },
  updatePassword: {
    uri: 'users/%user%/password',
    method: 'PUT',
    loading: true,
    subdomain: true,
    needsVerified: true
  },
  getLine: {
    uri: 'lines/%line%',
    method: 'GET',
    loading: true,
    subdomain: true,
    needsVerified: false
  },
  getInLine: {
    uri: 'lines',
    method: 'POST',
    loading: true,
    subdomain: true,
    needsVerified: true
  },
  getOutOfLine: {
    uri: 'lines/%line%',
    method: 'DELETE',
    loading: true,
    subdomain: true,
    needsVerified: false
  },
  getLines: {
    uri: 'users/%user%/lines',
    method: 'GET',
    loading: true,
    subdomain: true,
    needsVerified: false
  },
  lineStatusChange: {
    uri: 'lines/%line%/session',
    method: 'PUT',
    loading: true,
    subdomain: true,
    needsVerified: false
  },
  getAddresses: {
    uri: 'users/%user%/addresses',
    method: 'GET',
    loading: true,
    subdomain: true,
    needsVerified: false
  },
  saveAddress: {
    uri: 'users/%user%/addresses',
    method: 'POST',
    loading: true,
    subdomain: true,
    needsVerified: true
  },
  deleteAddress: {
    uri: 'users/%user%/addresses/%address%',
    method: 'DELETE',
    loading: true,
    subdomain: true,
    needsVerified: true
  },
  updateAddress: {
    uri: 'users/%user%/addresses/%address%',
    method: 'PUT',
    loading: true,
    subdomain: true,
    needsVerified: true
  },
  getCarts: {
    uri: 'users/%user%/carts',
    method: 'GET',
    loading: true,
    subdomain: true,
    needsVerified: false
  },
  sendChatMessage: {
    uri: 'carts/%cart%/messages',
    method: 'POST',
    subdomain: true,
    needsVerified: true
  },
  getChatMessages: {
    uri: 'carts/%cart%/messages',
    method: 'GET',
    subdomain: true,
    needsVerified: true
  },
  saveCardDetails: {
    uri: 'users/%user%/payment_details',
    method: 'POST',
    subdomain: true,
    needsVerified: true
  },
  saveCardDetailsIntent: {
    uri: 'users/%user%/payment_details_intent',
    method: 'POST',
    subdomain: true,
    needsVerified: true
  },
  standardCardDetail: {
    uri: 'users/%user%/payment_details/%paymentdetail%',
    method: 'PUT',
    subdomain: true,
    needsVerified: true
  },
  getCardDetails: {
    uri: 'users/%user%/payment_details',
    method: 'GET',
    subdomain: true,
    needsVerified: false
  },
  deleteCardDetails: {
    uri: 'users/%user%/payment_details/%paymentdetail%',
    method: 'DELETE',
    subdomain: true,
    needsVerified: true
  },
  resetPassword: {
    uri: 'account/password/reset/%token%',
    method: 'POST',
    subdomain: true,
    needsVerified: false
  },
  resendVerificationLink: {
    uri: 'account/verify',
    method: 'POST',
    subdomain: true,
    needsVerified: false
  },
  verifyAccount: {
    uri: 'account/verify/%token%',
    method: 'GET',
    subdomain: true,
    needsVerified: false
  },
  sendPasswordLink: {
    uri: 'account/password/request',
    method: 'POST',
    subdomain: true,
    needsVerified: false
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/endpoints/user.js